import { getUserTimezone } from '@occc-app/lib/date';

import { useGetRetailerNetworkLocationGroupOnlineStatusQuery } from '../../../data-access/queries';

type UseLocationGroupOnlineStatusOptions = {
  groupUuid: string;
  networkId: string;
  skip?: boolean;
};

type UseLocationGroupOnlineStatusResult = {
  offlineCount: number;
};

export const useLocationGroupOnlineStatus = ({
  groupUuid,
  networkId,
  skip = false,
}: UseLocationGroupOnlineStatusOptions): UseLocationGroupOnlineStatusResult => {
  const { data } = useGetRetailerNetworkLocationGroupOnlineStatusQuery(
    {
      variables: {
        filter: {
          retailerNetworkUuidEquals: networkId,
          retailerNetworkLocationGroupUuidIn: [groupUuid],
          timezone: getUserTimezone(),
        },
      },
    },
    skip,
  );

  const offlineCount = data ? data.numberOfStores - data.numberOfConnectedStores : 0;

  return { offlineCount };
};
